import { gql } from "@apollo/client";

export default gql`
  mutation RemoveDiabeticPatient($patientId: Float!) {
    removeDiabeticPatient(patientId: $patientId)
  }
`;
